module.exports = __webpack_public_path__ + "static/media/announcement-selected.1fbdb497.svg";